import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { navLinks, siteInfo } from '@/mocks/site';

function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const overlay = location.pathname === '/' && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        overlay
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/80'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-[72px] items-center justify-between gap-4">
          <Link
            to="/"
            className="flex items-center gap-2.5 shrink-0 cursor-pointer"
            aria-label="网报吃瓜首页"
          >
            <span
              className={`flex h-9 w-9 items-center justify-center rounded-lg w-9 h-9 text-lg ${
                overlay ? 'bg-background-50 text-primary-700' : 'bg-primary-500 text-background-50'
              }`}
            >
              <i className="ri-fire-line" />
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-lg font-bold tracking-wide ${
                  overlay ? 'text-background-50' : 'text-foreground-950'
                }`}
              >
                {siteInfo.name}
              </span>
              <span
                className={`mt-0.5 text-[11px] hidden sm:block ${
                  overlay ? 'text-background-100/80' : 'text-foreground-600'
                }`}
              >
                {siteInfo.slogan}
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                    overlay
                      ? isActive
                        ? 'bg-background-50/20 text-background-50'
                        : 'text-background-100 hover:bg-background-50/15'
                      : isActive
                        ? 'bg-primary-100 text-primary-800'
                        : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/feed"
              className={`hidden sm:inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                overlay
                  ? 'bg-background-50 text-foreground-950 hover:bg-background-100'
                  : 'bg-primary-500 text-background-50 hover:bg-primary-600'
              }`}
            >
              <i className="ri-flashlight-fill" />
              看实时快讯
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开导航菜单"
              aria-expanded={menuOpen}
              className={`md:hidden flex h-10 w-10 items-center justify-center rounded-md text-xl cursor-pointer ${
                overlay ? 'text-background-50' : 'text-foreground-900'
              }`}
            >
              <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200/80 bg-background-50 px-4 pb-4 pt-2">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium ${
                    isActive
                      ? 'bg-primary-100 text-primary-800'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}

export default SiteHeader;